import { createAction } from "@reduxjs/toolkit";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const removeFromStudentFavorite = createApiThunk<void, string>(
  "teacher/removeFromStudentFavorite",
  async (studentId: string, { extra: { teacherRepository } }) => {
    return teacherRepository!.removeFromStudentFavorite(studentId);
  },
);

export const resetRemoveFromStudentFavorite = createAction("teacher/resetRemoveFromStudentFavorite");
